// Определяем доступные локали
export const defaultLocale = 'en';
export type LocaleType = 'en' | 'ru' | 'fr' | 'it';
export const locales: LocaleType[] = ['en', 'ru', 'fr', 'it'];
export type Locale = (typeof locales)[number];
